import { FeatureDisplayItem } from './featureDisplayItem';
import 'jquery';

export class PaginatedFeatures {
  public static readonly CSS_CLASS = 'paginated-features';
  public static readonly WRAPPER_CSS_CLASS = PaginatedFeatures.CSS_CLASS + '-wrapper';
  protected currentSlide = 0;

  protected slides = new Array<HTMLElement>();
  protected content: HTMLElement;
  protected slideWrapper: HTMLElement;

  protected navText: HTMLElement;
  protected prevButts: HTMLElement;
  protected nextButts: HTMLElement;

  constructor(protected leafletMap: L.Map, protected featureItemsPromise: Promise<Array<FeatureDisplayItem>>) { }

  public getDisplayItem(): Promise<null | HTMLElement> {
    // Create the div which holds the header and content
    // Initially set to display loading spinner
    this.content = jQuery(`<div class="${PaginatedFeatures.CSS_CLASS}"></div>`)[0];

    this.slideWrapper = jQuery(
      '<div class="slide-wrapper pretty-scroll limit-size"><i class="spinner fas fa-spinner fa-pulse"></i></div>',
    )[0];
    jQuery(this.content).append(this.slideWrapper);
    // take out of flow to ensure function returns immediately
    return this.createSlides().then(() => {
      // add slides
      this.slides.forEach((slide) => jQuery(this.slideWrapper).append(slide));

      jQuery(this.content).append(this.createNavigation());

      if (this.slides.length > 0) {
        this.changeSlide();
        return this.content;
      } else {
        return null;
      }
    });
  }

  protected createSlides(): Promise<void> {
    // loops through all the features
    return this.featureItemsPromise.then((featureItems: Array<FeatureDisplayItem>) => {
       
      this.slides = featureItems
        .map((featureItem: FeatureDisplayItem) => {
          let slide: null | HTMLElement = null;
          if (null != featureItem) {
            const featureDisplayContent = featureItem.getContent();
            if (null != featureDisplayContent) {
              slide = jQuery('<div class="slide"></div>')[0];
              if (null != featureItem.click) {
                slide.addEventListener('click', (event) => {
                   
                  featureItem.click!(event);
                });
              }

              if (featureDisplayContent instanceof HTMLElement) {
                jQuery(slide).append(featureDisplayContent);
              } else {
                jQuery(slide).html(String(featureDisplayContent));
              }
            }
          }
          return slide;
        })
        .filter((slide) => slide != null) as Array<HTMLElement>;
    });
  }

  protected createNavigation(): JQuery {
    // nav
    const nav = jQuery(`
            <div class="slide-navigation">
              <span class="nav nav-prev disable"></span>
              <span class="nav-text"></span>
              <span class="nav nav-next disable"></span>
            </div>
          `);
    this.navText = jQuery(nav).find('.nav-text')[0];
    this.prevButts = jQuery(nav).find('.nav.nav-prev')[0];
    this.nextButts = jQuery(nav).find('.nav.nav-next')[0];

    const orderOfMagnitude = this.slides.length.toString().length;
    const magnitudeStrings = ['One', 'Ten', 'One Hundred', 'One Thousand'];

    const makeButtons = (wrapper: HTMLElement, iconClassString: string, isnext: boolean) => {
      const navString = isnext ? 'Forward' : 'Back';
      for (let i = 0; i < orderOfMagnitude; i++) {
        const butt = jQuery(`<span class="nav-butt" title="${navString} ${magnitudeStrings[i]}"></span>`);
        butt.on('click', () => this.changeSlide(isnext, Math.pow(10, i)));
        for (let j = 0; j <= i; j++) {
          butt.append(jQuery(`<i class="${iconClassString}"></i>`));
        }
        jQuery(wrapper).append(butt);
      }
    };
    makeButtons(this.prevButts, 'fas fa-chevron-left', false);
    makeButtons(this.nextButts, 'fas fa-chevron-right', true);
    return nav;
  }

  protected changeSlide(next?: boolean, howMuch = 1): void {
    let slideToSelect = this.currentSlide;
    slideToSelect = next === true ? slideToSelect + howMuch : slideToSelect;
    slideToSelect = next === false ? slideToSelect - howMuch : slideToSelect;
    slideToSelect = slideToSelect < 0 ? 0 : slideToSelect;
    slideToSelect = slideToSelect > this.slides.length - 1 ? this.slides.length - 1 : slideToSelect;
    if (slideToSelect === this.slides.length - 1) {
      jQuery(this.nextButts).addClass('disable');
    } else {
      jQuery(this.nextButts).removeClass('disable');
    }
    if (slideToSelect === 0) {
      jQuery(this.prevButts).addClass('disable');
    } else {
      jQuery(this.prevButts).removeClass('disable');
    }

    // deselect old slide
    jQuery(this.slideWrapper).find('.slide.selected').removeClass('selected');
    // select new slide, targets the div id which is set by looping through all the marker layers
    jQuery(this.slideWrapper)
      .find(`.slide:nth-of-type(${slideToSelect + 1})`)
      .addClass('selected');

    jQuery(this.navText).html(`${slideToSelect + 1} of ${this.slides.length}`);

    this.currentSlide = slideToSelect;
  }
}
